module.exports = __webpack_public_path__ + "img/user-img.1f996dde.svg";